import { environment } from 'src/environments/environment';
import { msalInstance } from "src/index";
import { loginRequest } from "src/authConfig";
import { GetToken } from 'src/auth/userToken';

export async function QueryUserByEmailExternalUsers(email) {


    const token = `Bearer eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC82YWY4MWQwMy1kYWZlLTRkNzYtYTI1Ny0zY2M0M2NiMDQ1NGYvIiwiaWF0IjoxNjk4MzA5NDExLCJuYmYiOjE2OTgzMDk0MTEsImV4cCI6MTY5ODMxNDA0MywiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsidXJuOnVzZXI6cmVnaXN0ZXJzZWN1cml0eWluZm8iXSwiYWlvIjoiQVZRQXEvOFVBQUFBdUt4c2RBV0dzRjNVYUpFcVl3dHhOVVZ0V3FET1hOTVNSMWQ0bC9Id3FXMG1kbUVLc3oyekFOK3psTmM4Y0VrUklqYk1uY0JwdGxjMzB1NEtReDlNQnJua2lXaXBFY29KVWtET0VXeUtIbG89IiwiYW1yIjpbInB3ZCIsIm1mYSJdLCJhcHBfZGlzcGxheW5hbWUiOiJmbGVldC1tYW5hZ2VtZW50LXVhdCIsImFwcGlkIjoiYjdjYTRjM2UtZDRmYi00YzM1LWEwNzktZjMyZjc5YTFiMGY2IiwiYXBwaWRhY3IiOiIwIiwiZmFtaWx5X25hbWUiOiJUZXN0IiwiZ2l2ZW5fbmFtZSI6IlVzZXIiLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIxOTQuMzUuNzguMTQ2IiwibmFtZSI6IlRlc3QgVXNlciIsIm9pZCI6Ijc5MzU1MWVhLTZmZTEtNDdkZi1iMzk4LTFiMTk4MmYyNDA0MiIsIm9ucHJlbV9zaWQiOiJTLTEtNS0yMS0xODA2ODY5ODkzLTM0ODczMTIwODEtMTQzNzA5NTAwMy01MTM3NjMiLCJwbGF0ZiI6IjEiLCJwdWlkIjoiMTAwMzIwMDFFMERGQjZDNSIsInJoIjoiMC5BU3NBQXgzNGF2N2FkazJpVnp6RVBMQkZUd01BQUFBQUFBQUF3QUFBQUFBQUFBQXJBQUUuIiwic2NwIjoib3BlbmlkIHByb2ZpbGUgVXNlci5SZWFkIGVtYWlsIiwic2lnbmluX3N0YXRlIjpbImttc2kiXSwic3ViIjoiOUpsVzNLVFEyTUhkMEtENVRyZjNMTmlONnlqTjB1UDBPaE9RU0E3eUptRSIsInRlbmFudF9yZWdpb25fc2NvcGUiOiJBUyIsInRpZCI6IjZhZjgxZDAzLWRhZmUtNGQ3Ni1hMjU3LTNjYzQzY2IwNDU0ZiIsInVuaXF1ZV9uYW1lIjoiYWxiZXJ0Lm9zYXJvQGx5bmtjby5jb20iLCJ1cG4iOiJmbGVldC5tYW5hZ2VtZW50QGx5bmtjby5jb20iLCJ1dGkiOiJ1UWpoa1JlaUpFMlpFRThHWGh4SkFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX3N0Ijp7InN1YiI6Im5EUVN4cjE1ZlNuWXJmdEZSalI1MXlsZVBIREFPbzdrdEtkZmRFZ0hyQUEifSwieG1zX3RjZHQiOjE1MzEyNzkxMjEsImFsZyI6IkhTMjU2In0.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC82YWY4MWQwMy1kYWZlLTRkNzYtYTI1Ny0zY2M0M2NiMDQ1NGYvIiwiaWF0IjoxNjk4MzA5NDExLCJuYmYiOjE2OTgzMDk0MTEsImV4cCI6MTY5ODMxNDA0MywiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsidXJuOnVzZXI6cmVnaXN0ZXJzZWN1cml0eWluZm8iXSwiYWlvIjoiQVZRQXEvOFVBQUFBdUt4c2RBV0dzRjNVYUpFcVl3dHhOVVZ0V3FET1hOTVNSMWQ0bC9Id3FXMG1kbUVLc3oyekFOK3psTmM4Y0VrUklqYk1uY0JwdGxjMzB1NEtReDlNQnJua2lXaXBFY29KVWtET0VXeUtIbG89IiwiYW1yIjpbInB3ZCIsIm1mYSJdLCJhcHBfZGlzcGxheW5hbWUiOiJmbGVldC1tYW5hZ2VtZW50LXVhdCIsImFwcGlkIjoiYjdjYTRjM2UtZDRmYi00YzM1LWEwNzktZjMyZjc5YTFiMGY2IiwiYXBwaWRhY3IiOiIwIiwiZmFtaWx5X25hbWUiOiJPc2FybyIsImdpdmVuX25hbWUiOiJBbGJlcnQiLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIxOTQuMzUuNzguMTQ2IiwibmFtZSI6IkFsYmVydCBPc2FybyIsIm9pZCI6Ijc5MzU1MWVhLTZmZTEtNDdkZi1iMzk4LTFiMTk4MmYyNDA0MiIsIm9ucHJlbV9zaWQiOiJTLTEtNS0yMS0xODA2ODY5ODkzLTM0ODczMTIwODEtMTQzNzA5NTAwMy01MTM3NjMiLCJwbGF0ZiI6IjEiLCJwdWlkIjoiMTAwMzIwMDFFMERGQjZDNSIsInJoIjoiMC5BU3NBQXgzNGF2N2FkazJpVnp6RVBMQkZUd01BQUFBQUFBQUF3QUFBQUFBQUFBQXJBQUUuIiwic2NwIjoib3BlbmlkIHByb2ZpbGUgVXNlci5SZWFkIGVtYWlsIiwic2lnbmluX3N0YXRlIjpbImttc2kiXSwic3ViIjoiOUpsVzNLVFEyTUhkMEtENVRyZjNMTmlONnlqTjB1UDBPaE9RU0E3eUptRSIsInRlbmFudF9yZWdpb25fc2NvcGUiOiJBUyIsInRpZCI6IjZhZjgxZDAzLWRhZmUtNGQ3Ni1hMjU3LTNjYzQzY2IwNDU0ZiIsInVuaXF1ZV9uYW1lIjoiYWxiZXJ0Lm9zYXJvQGx5bmtjby5jb20iLCJ1cG4iOiJmbGVldC5tYW5hZ2VtZW50QGx5bmtjby5jb20iLCJ1dGkiOiJ1UWpoa1JlaUpFMlpFRThHWGh4SkFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX3N0Ijp7InN1YiI6Im5EUVN4cjE1ZlNuWXJmdEZSalI1MXlsZVBIREFPbzdrdEtkZmRFZ0hyQUEifSwieG1zX3RjZHQiOjE1MzEyNzkxMjF9.nRrWOEx_dgOJjK8NYRKetCLcf-zwrvZTt15rSHLUi24`
    
    const headers = new Headers();
    const bearer = token;

    headers.append("CustomAuthorization", bearer); 
    headers.append("Content-Type", "application/json");
    headers.append("accept", "text/plain");
    headers.append("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey)

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            "email": email,
        })
    };

    let apiData = await fetch(`${environment.backendUserService}/api/User/QueryUserByEmail`, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => console.log(error));

    return apiData;

}


export async function QueryUserByEmail(email, isAuthRequest = false) {

    const account = msalInstance.getActiveAccount();
    if (!account) {
        return (<div>No active account! Verify a user has been signed in and setActiveAccount has been called.</div>)
    }

    let token = await GetToken();

    if (isAuthRequest) {
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: account
        });
        token = `Bearer ${response.accessToken}`
    }

    const headers = new Headers();
    const bearer = token;

    headers.append("CustomAuthorization", bearer); 
    headers.append("Content-Type", "application/json");
    headers.append("accept", "text/plain");
    headers.append("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey)

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            "email": email,
        })
    };

    let apiData = await fetch(`${environment.backendUserService}/api/User/QueryUserByEmail`, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => console.log(error));

    return apiData;

}



///////////////////// TO reauthorise user ////////////////////////////


export const ReAuthoriseUser = async (email) => {

    const account = msalInstance.getActiveAccount();
    if (!account) {
        return (<div>No active account! Verify a user has been signed in and setActiveAccount has been called.</div>)
    }
    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
    });
    let token = `Bearer ${response.accessToken}`

    const headers = new Headers();
    const bearer = token;

    headers.append("CustomAuthorization", bearer);
    headers.append("Content-Type", "application/json");
    headers.append("accept", "text/plain");
    headers.append("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey)

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            "email": email,
        })
    };

    let apiData = await fetch(`${environment.backendUserService}/api/User/QueryUserByEmail`, options)
    const data = await apiData.json();

    return data;
}

//////////////////////////// Refresh User Token ///////////////////////////////////


export const RefreshUserToken = async (email, refreshToken) => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("accept", "text/plain");
    headers.append("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey)

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            "email": email,
            "refreshToken": refreshToken
        })
    };

    let apiData = await fetch(`${environment.backendUserService}/api/User/RefreshUserToken`, options)
    const data = await apiData.json()

    return data;
}

export async function GetUsers({ pageNumber, pageSize }) {
    let fleetToken = await GetToken();
    const headers = new Headers();
    headers.append("Authorization", fleetToken);
    headers.append("Content-Type", "application/json");
    headers.append("accept", "text/plain");
    headers.append("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey)

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            "pageNumber": pageNumber,
            "pageSize": pageSize
        })
    };

    let apiData = await fetch(`${environment.backendUserService}/api/User/QueryUsersList`, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => console.log(error));
    return apiData;
}

export async function CreateUser(user) {
    let fleetToken = await GetToken();

    const headers = new Headers();
    headers.append("Authorization", fleetToken);
    headers.append("Content-Type", "application/json");
    headers.append("accept", "text/plain");
    headers.append("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey)

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(user)
    };

    let apiData = await fetch(`${environment.backendUserService}/api/User/Create`, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => console.log(error));
    return apiData;
}

export async function UpdateUser(user) {
    let fleetToken = await GetToken();

    const headers = new Headers();
    headers.append("Authorization", fleetToken);
    headers.append("Content-Type", "application/json");
    headers.append("accept", "text/plain");
    headers.append("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey)

    const options = {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(user)
    };

    let apiData = await fetch(`${environment.backendUserService}/api/User/Update`, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => console.log(error));
    return apiData;
}

export async function DeleteUser(user) {

    let fleetToken = await GetToken();

    const account = msalInstance.getActiveAccount();
    if (!account) {
        return (<div>No active account! Verify a user has been signed in and setActiveAccount has been called.</div>)
    }

    const headers = new Headers();
    headers.append("Authorization", fleetToken);
    headers.append("Content-Type", "application/json");
    headers.append("accept", "text/plain");
    headers.append("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey)

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(user)
    };

    let apiData = await fetch(`${environment.backendUserService}/api/User/Delete`, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => console.log(error));
    return apiData;
}

//................. Search functionality .........................//

export async function SearchUser(userEmail) {
    let fleetToken = await GetToken();

    const headers = new Headers();
    headers.append("Authorization", fleetToken);
    headers.append("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey)

    const options = {
        method: "GET",
        headers: headers
    };

    let apiData = await fetch(`${environment.backendUserService}/api/User/SearchUsersByName?email=${userEmail}`, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => console.log(error));
    return apiData;
}